import { Flex } from 'antd';
import { ChatHistoryUserItem } from 'api/FlowAiApi';
import UserAvatar from 'components/UiKit/UserAvatar/UserAvatar';
import { useSelector } from 'react-redux';
import { selectAuthUser } from 'store/authSlice';
import './UserBubble.css';

type AllProps = {
  data: ChatHistoryUserItem;
};

function UserBubble({ data }: AllProps) {
  const user = useSelector(selectAuthUser);

  return (
    <div className="user-bubble-container">
      <Flex align="start" gap={10}>
        <div className="user-bubble">{data.message}</div>
        <div>
          <UserAvatar size={32} user={user} />
        </div>
      </Flex>
    </div>
  );
}
export default UserBubble;
